//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isNumber } from '@/utils';
export default {
  name: 'run_notice',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      message: ['这里是消息标题，欢迎使用跑马灯组件', '优联商城跑马灯组件上线啦', '跑马灯吱呀之悠悠的转'],
      animationDuration: '10s'
    };
  },
  methods: {
    calcDuration: function calcDuration() {
      var message_speed = this.value.config.message_speed;
      if (!isNumber(message_speed)) {
        this.animationDuration = '10s';
        return;
      }
      // const baseSize = 16
      // const currentSize = document.documentElement.style.fontSize.replace(
      // 	/[^0-9.]/g,
      // 	''
      // )
      // const textWidth = (this.$refs.text.clientWidth / currentSize) * baseSize
      // this.animationDuration = `${textWidth / message_speed + 0.5}s` // 因为像素单位等问题 +0.5s 之后的时间 跟C端计算出来的时间才大约一致
      this.animationDuration = "".concat(this.$refs.text.clientWidth / message_speed - 0.35, "s"); // 因为像素单位等问题 +0.5s 之后的时间 跟C端计算出来的时间才大约一致
    }
  },
  mounted: function mounted() {
    this.calcDuration();
  },
  watch: {
    'value.config.message_speed': {
      handler: function handler() {
        this.calcDuration();
      } // immediate: true
    }
  },
  computed: {
    Styles: function Styles() {
      var _this$value$config = this.value.config,
        _this$value$config$ba = _this$value$config.background_color,
        background_color = _this$value$config$ba === void 0 ? '#FFFBEA' : _this$value$config$ba,
        _this$value$config$fo = _this$value$config.font_size,
        font_size = _this$value$config$fo === void 0 ? 28 : _this$value$config$fo,
        _this$value$config$fo2 = _this$value$config.font_color,
        font_color = _this$value$config$fo2 === void 0 ? '#dd722e' : _this$value$config$fo2,
        _this$value$config$ic = _this$value$config.icon_size,
        icon_size = _this$value$config$ic === void 0 ? 50 : _this$value$config$ic,
        _this$value$config$ic2 = _this$value$config.icon_color,
        icon_color = _this$value$config$ic2 === void 0 ? '#dd722e' : _this$value$config$ic2;
      var baseSize = 32; //基准值 16*2 C端即可直接取值

      var fontSize = font_size / baseSize;
      var iconSize = icon_size / baseSize;
      return {
        '--backgroundColor': background_color,
        '--iconSize': iconSize + 'rem',
        '--iconColor': icon_color,
        '--fontSize': fontSize + 'rem',
        '--fontColor': font_color,
        '--lineHeight': fontSize * 2 + 'rem'
      };
    }
  }
};